import * as actionCreators from '../actions/action.creators';
import { AppThunkAction } from '../../../../shared/infrastructure/store/store';
import { authService } from '../../../users/services/dependency.injection';
import { merchantService } from '../../services/dependency.injection';

export function getLiveMerchantByEmail(): AppThunkAction {
    
    return async (dispatch: any, getState?: any) => {
        if (authService.userInfo() === null) return;
        const { user_name }: any = authService.userInfo();
        const response = await merchantService.getLiveMerchantByEmail(user_name);

        if (response.isLeft()) {
            // const error = response.value;
            dispatch(actionCreators.getLiveMerchantFailure());
        } else {
            // const merchant = response.value.getValue();
            dispatch(actionCreators.getLiveMerchantSuccess());
        }
    };
}
